import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getUserData();
    const requiredRoles = route.data['roles'] as string[];
    const permissionModule = route.data['permissionModule'] as string;
    
    // If no user, redirect to login
    if (!user) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // 1. Check role access: roles.includes(user.code_role)
    if (requiredRoles && requiredRoles.length > 0) {
      if (!requiredRoles.includes(user.code_role)) {
        this.router.navigate(['/access-denied']);
        return false;
      }
    }

    // 2. Check module permission access
    if (permissionModule) {
      if (!this.authService.hasModuleAccess(permissionModule)) {
        this.router.navigate(['/access-denied']);
        return false;
      }
    }

    return true;
  }
}